$(document).ready(function(){
  
  //Affix Main Menu

  $('.mainMenu-wrap').affix({
    offset: {
      top: 0
      /*top: function () {
        return (this.top = $('.fixed-nav-wrapper').outerHeight(true) + 67)
      }*/
    }
  });
  
  $(window).scroll(function() {
    console.log("Window is scrolling");
    if($(".mainMenu-wrap").hasClass("affix")) {
      $(".topNav-wrap").css({"height": "47px", "background":"#FFF"});
    }
  });
  
  //Flexslider
  $('.flexslider').flexslider({
    animation: "fade"
  });
  
  //Fancybox
  $('.fancybox').fancybox();
  $('.gallery').fancybox();
  
  
  // Conditional logic --------------------------------------------------------------------------------
  
//   function disallowCanvas(canvas){
//     if ( canvas === "triptych" ){
//       $('.type-of-canvas li').removeClass('disallow-click');
//       $('.type-of-canvas li.triptych-canvas').addClass('disallow-click');
//     }
//     if ( canvas === "nontriptych"){
//       $('.type-of-canvas li').addClass('disallow-click');
//       $('.type-of-canvas li.triptych-canvas').removeClass('disallow-click');
//     }
//   }
  
//   function disallowSize(size){
//     if ( size === "triptych" ){
//     	$('.size-of-canvas li').addClass('disallow-click');
//     	$('.size-of-canvas li.3-12x12, .size-of-canvas li.3-20x20, .size-of-canvas li.3-30x30').removeClass('disallow-click');
//     }
//     if ( size === "nontriptych"){
// 		$('.size-of-canvas li').removeClass('disallow-click');
//     	$('.size-of-canvas li.3-12x12, .size-of-canvas li.3-20x20, .size-of-canvas li.3-30x30').addClass('disallow-click');
//     }
//   }
  
//   function resetDefault(formtype,formclass){
//   	$('.swatch .'+formtype+'-of-canvas li.'+formclass).trigger('click');
//   }
  

//   var tripSizes = ["12X36","15X45","18X58"];
//   var initSize = $('.size-of-canvas li.selected span').text();
  
//   if ( tripSizes.indexOf(initSize) > -1 ){
//     console.log('disabling triptych');
//     disallowCanvas('triptych');

//   }
//   else {
//     console.log('disabling non triptych');
//     disallowCanvas('nontriptych');
//   }

  
//   $('.size-of-canvas li').each(function(){
//     $(this).click(function(){
      
//       var thisSize = $(this).find('span').text();
      
//       console.log(thisSize+' was clicked');

//       if ( tripSizes.indexOf(thisSize) > -1 ){
//         console.log('disabling triptych');
//         disallowCanvas('triptych');
        
//       }
//       else {
//         console.log('disabling non triptych');
//       	disallowCanvas('nontriptych');
//       }

//     });
//   });
  
//   $('.type-of-canvas li').each(function(){
//     $(this).click(function(){
      
//       var tripCanvas = ["Triptych Canvas"];
//       var thisCanvas = $(this).find('span').text();
      
//       console.log(thisCanvas+' was clicked');

//       if ( tripCanvas.indexOf(thisCanvas) > -1 ){
//         console.log('disabling non triptych canvas');
//       	disallowSize('triptych');
//       }
//       else {  
//         console.log('disabling triptych canvas');
//         disallowSize('nontriptych');
//       }

//     });
//   });
  

  //$('#product-add').before('<a class="variations-reset" onClick="document.location.reload(true)">RESET CANVAS OPTIONS</a>');  
  
});